import * as React from "react"
import { observer } from "mobx-react"
import { MembersMapI } from "../../BookingFlow"
import ToggleSwitch from "../../components/ToggleSwitch"
import { Flex } from "rebass"
import theme from "../../theme"
import { Member } from "BookingSystem/db/Member"
import { TableHeading } from "BookingSystem/components/TableHeading"

@observer
export class MembersEditorComp extends React.Component<{
  model: MembersMapI
}> {
  render() {
    const { model } = this.props
    const { memberList, isSelectable } = model

    return (
      <Flex id="MemberEditorComp" flexDirection={["column"]} mb={3}>
        <Flex
          ml={3}
          style={{ borderBottom: "solid 1px rgba(255,255,255, 0.1)" }}
        >
          {isSelectable ? (
            <Flex justifyContent="center" alignItems="center" width={[0.16]} />
          ) : null}
          <TableHeading width={isSelectable ? [0.33] : [0.36]}>
            Name
          </TableHeading>
          <Flex
            alignItems="center"
            justifyContent="center"
            color={theme.colors.text}
            fontSize={["0.9rem", "1.1rem", "1.5rem"]}
            style={{
              fontWeight: 800,
              textAlign: "center",
              color: theme.colors.text
            }}
            width={isSelectable ? [0.25] : [0.16]}
            p={["0.5rem", "0.75rem"]}
          >
            Adult
          </Flex>
          <Flex
            alignItems="center"
            justifyContent="center"
            color={theme.colors.text}
            p={["0.5rem", "0.75rem"]}
            fontSize={["0.9rem", "1.1rem", "1.5rem"]}
            style={{
              fontWeight: 800,
              textAlign: "center",
              color: theme.colors.text
            }}
            width={[0.16]}
          >
            Waiver
          </Flex>
          {!isSelectable && (
            <Flex
              width={[0.16]}
              p={["0.5rem", "0.75rem"]}
              alignItems="center"
              justifyContent="center"
              fontSize={["0.9rem", "1.1rem", "1.5rem"]}
              style={{
                fontWeight: 800,
                textAlign: "center",
                color: theme.colors.text
              }}
            >
              Edit
            </Flex>
          )}
          {!isSelectable && (
            <Flex
              width={[0.16]}
              p={["0.5rem", "0.75rem"]}
              alignItems="center"
              justifyContent="center"
              fontSize={["0.9rem", "1.1rem", "1.5rem"]}
              style={{
                fontWeight: 800,
                textAlign: "center",
                color: theme.colors.text
              }}
            >
              Remove
            </Flex>
          )}
        </Flex>
        <Flex id="member-list" flexDirection="column">
          {memberList.map((member: Member, i) => (
            <Flex
              ml={3}
              key={i}
              className="member-list-item"
              style={{
                color: theme.colors.text,
                fontSize: window.innerWidth > 600 ? 18 : 14
              }}
            >
              {isSelectable && (
                <Flex alignItems="center" width={[0.16]}>
                  <ToggleSwitch
                    type="checkbox"
                    className="toggle"
                    defaultChecked={model.has(member)}
                    onClick={() => {
                      model.toggleMembership(member)
                    }}
                  />
                </Flex>
              )}
              <Flex
                alignItems="center"
                width={isSelectable ? [0.33] : [0.36]}
                p={["0.5rem", "0.75rem"]}
                fontSize={["0.75rem", "1rem", "1.25rem"]}
              >
                {member.fullName}
              </Flex>
              <Flex
                alignItems="center"
                justifyContent="center"
                width={isSelectable ? [0.25] : [0.16]}
                p={["0.5rem", "0.75rem"]}
              >
                {member.isMinor ? "Minor" : "Adult"}
              </Flex>
              <Flex
                alignItems="center"
                justifyContent="center"
                width={[0.16]}
                p={["0.5rem", "0.75rem"]}
              >
                {member.waivers && member.waivers.length ? (
                  <Flex alignItems="center" color={theme.colors.text}>
                    Yes
                  </Flex>
                ) : (
                  <Flex alignItems="center" color={theme.colors.text}>
                    No
                  </Flex>
                )}
              </Flex>
              {model.isEditable && (
                <Flex
                  id="edit"
                  width={isSelectable ? [0] : [0.16]}
                  p={["0.5rem", "0.75rem"]}
                  alignItems="center"
                  justifyContent="center"
                >
                  <i
                    className="fas fa-edit"
                    style={{ margin: "1%", cursor: "pointer" }}
                    onClick={() => {
                      model.onEdit && model.onEdit(member)
                    }}
                  />
                </Flex>
              )}
              {model.isEditable && (
                <Flex
                  id="delete"
                  width={isSelectable ? [0] : [0.16]}
                  p={["0.5rem", "0.75rem"]}
                  alignItems="center"
                  justifyContent="center"
                >
                  <i
                    className="fas fa-trash-alt"
                    style={{ margin: "1%", cursor: "pointer" }}
                    onClick={() => {
                      model.onDelete && model.onDelete(member)
                    }}
                  />
                </Flex>
              )}
            </Flex>
          ))}
        </Flex>
      </Flex>
    )
  }
}
